import {
  logoSVG,
  payAppSVG,
  downloadAppSVG,
  accountSVG,
  meterNumberSVG,
  roleSVG,
  userSVG,
  amountSVG,
  alreadyPaidSVG,
  newLogo,
  pngLogo,
  downloadAppArSVG,
  payAppArSVG,
} from "./for-pdf";

const logoSize = 125;
const qrCodeSize = 186;
const paymentGtSize = 270;
const bgColor = "#fff4eb";

const emptyCell3=[
  {
    border: [false, false, false, false],
    fillColor: '#fff4eb',
    text:' '
  },
  {
    border: [false, false, false, false],
    fillColor: '#fff4eb',
    text:' '
  },
  {
    border: [false, false, false, false],
    fillColor: '#fff4eb',
    text:' '
  },
];
const emptyCellSingle={
  border: [false, false, false, false],
  fillColor: '#fff4eb',
  text:' '
};

const translations = {
  ar: {
    accountNumTitle: "رقم الحساب",
    roleTitle: "نوع الاستفادة", //"دور",
    meterNumTitle: "رقم العداد",
    nicknameTitle: "الاسم المستعار", //"لقب",
    totalAmountTitle: "المبلغ الإجمالي",
    remainingAmountTitle: "المبلغ المتبقي",
    alreadyPaidTitle: "مدفوع بالفعل",
  },
  en: {
    accountNumTitle: "Account Number",
    roleTitle: "Role",
    meterNumTitle: "Meter Number",
    nicknameTitle: "Nickname",
    totalAmountTitle: "Total amount",
    remainingAmountTitle: "Remaining amount",
    alreadyPaidTitle: "Already paid",
  },
};

const singleLineheight = 435;
const convertTextToRtl = (text) => {
  let conv = text.split(" ").reverse().join("  ");
  // console.log(conv);
  return conv;
};

const setHeightBasedOnString=(str)=> {
  const arabicPattern = /[\u0600-\u06FF]/; // Arabic Unicode block
  // const englishPattern = /[a-zA-Z?/!@#$%^&*()_+\-=\[\]{};':"\\|,.<>`~]/; //For All
  const englishPattern = /[A-Za-z?/-]/;

  let breakLength;
  let splitStrings = [];

  const hasArabic = arabicPattern.test(str);
  const hasEnglish = englishPattern.test(str);

  if (hasArabic && hasEnglish) {
      breakLength = 20; // Combined text
  } else if (hasArabic) {
      breakLength = 22; // Only Arabic
  } else if (hasEnglish) {
      breakLength = 20; // Only English
  } else {
      return { height: 0, splitStrings: [] };
  }

  if ((hasEnglish && !hasArabic && str.length < 22) || (hasArabic && !hasEnglish && str.length < 22)) {
      return { height: singleLineheight, splitStrings: [str] };
  }

  let words = str.split(' ');
  let currentString = "";

  words.forEach((word, index) => {
      if ((currentString + word).length <= breakLength) {
          currentString += (currentString.length > 0 ? ' ' : '') + word;
      } else {
          splitStrings.push(currentString + '\n');
          currentString = word;
      }

      // For the last word
      if (index === words.length - 1) {
          splitStrings.push(currentString);
      }
  });

  splitStrings[splitStrings.length - 1] = splitStrings[splitStrings.length - 1].replace(/\n$/, '');

  const count = splitStrings.length;

  const heightMap = {
      2: hasArabic? 469: 469,
      3: 499,
      4: 529,
      5: 559,
      6: 589
  };

  const height = heightMap[count] || 0; // Adjust as needed for other counts

  return { height, splitStrings };
}

const pageheight = (data, cardType)=>{
  if(cardType==="AccountInfoWithName"){
    const item = data.find(entry => entry.name === "property_name");
    const propValue = setHeightBasedOnString(item.value || "-");
    // console.log(propValue)
    return propValue.height;
  }
  return singleLineheight;
}

const engBlock = (data={})=>{
  const { blockArray = [] } = data;
  const [blockOne=[], blockTwo=[], blockThree=[], blockFour=[]] = blockArray;
  let finalDoc = [
    {
      table: {
        widths: [20,'*',20],
        heights: ['*'],
        body: [
          emptyCell3,
          [
            emptyCellSingle,
            {
              border: [false, false, false, false],
              fillColor: bgColor,                  
              stack: [
                {
                  alignment: "left",
                  columns: [
                    {
                      image: pngLogo,
                      width: logoSize,
                    },
                    {
                      text: `  `,
                    },
                  ],
                  columnGap: 15,
                },
                {
                  text: `  `,
                },
                {
                  text: `  `,
                },
                {
                  alignment: "left",
                  columns: [
                    {
                      alignment: "left",
                      columns: blockOne,
                      columnGap: 15,
                    },
                    {
                      alignment: "left",
                      columns: blockTwo,
                      columnGap: 15,
                    },
                  ],
                },
                { text: `  ` },
                { text: `  ` },
                { text: `  ` },
                {
                  alignment: "right",
                  columns: [
                    {
                      alignment: "justify",
                      columns: blockThree,
                      columnGap: 15,
                    },
                    {
                      alignment: "justify",
                      columns: blockFour,
                      columnGap: 15,
                    },
                  ],
                },
                { text: `  ` },
                { text: `  ` },
                { text: `  ` },
                { text: `  ` },
                { text: `  ` },
                {
                  alignment: "left",
                  columns: [
                    {
                        alignment: "left",
                        columns: [
                          {
                            stack: [
                              {
                                svg: downloadAppSVG,
                                width: qrCodeSize,
                              },
                            ],
                            align: "left",
                          },
                        ],
                        columnGap: 15,
                      },
                    {
                      alignment: "right",
                      columns: [
                        {
                          stack: [
                            {
                              svg: payAppSVG,
                              width: paymentGtSize,
                            },
                          ],
                          align: "right",
                        },
                      ],
                      columnGap: 15,
                    },
                    
                  ],
                },
              ]
            },
            emptyCellSingle
          ],
          emptyCell3,
        ]
      }
    }
  ];

  return finalDoc;
}

const arbBlock = (data={})=>{
  const { blockArray = [] } = data;
  const [blockOne=[], blockTwo=[], blockThree=[], blockFour=[]] = blockArray;
  let finalDoc = [
    {
      table: {
        widths: [20,'*',20],
        heights: ['*'],
        body: [
          emptyCell3,
          [
            emptyCellSingle,
            {
              border: [false, false, false, false],
              fillColor: bgColor,                  
              stack: [
                {
                  alignment: "left",
                  columns: [
                    {
                      image: pngLogo,
                      width: logoSize,
                    },
                    {
                      text: `  `,
                    },
                  ],
                  columnGap: 15,
                },
                {
                  text: `  `,
                },
                {
                  text: `  `,
                },
                {
                  alignment: "right",
                  columns: [
                    {
                      alignment: "right",
                      columns: blockTwo,
                      columnGap: 15,
                    },
                    {
                      alignment: "right",
                      columns: blockOne,
                      columnGap: 15,
                    },                        
                  ],
                },
                { text: `  ` },
                { text: `  ` },
                { text: `  ` },
                {
                  alignment: "right",
                  columns: [
                    {
                      alignment: "right",
                      columns: blockFour,
                      columnGap: 15,
                    },
                    {
                      alignment: "right",
                      columns: blockThree,
                      columnGap: 15,
                    },                        
                  ],
                },
                { text: `  ` },
                { text: `  ` },
                { text: `  ` },
                { text: `  ` },
                { text: `  ` },
                {
                  alignment: "left",
                  columns: [                        
                    {
                      alignment: "left",
                      columns: [
                        {
                          stack: [
                            {
                              svg: downloadAppArSVG,
                              width: 215,
                            },
                          ],
                          align: "left",
                        
                        },
                      ],
                      columnGap: 15,
                    },
                    {
                      alignment: "right",
                      columns: [
                        {
                          stack: [
                            {
                              svg: payAppArSVG,
                              width: 185,
                            },
                          ],
                          align: "right",
                        },
                      ],
                      columnGap: 15,
                    },
                  ],
                },
              ]
            },
            emptyCellSingle
          ],
          emptyCell3,
        ]
      }
    }
  ];

  return finalDoc;
}

const isEnglish=(text)=> {
  const englishRegex = /[A-Za-z]/g;
  const englishLetters = text.match(englishRegex);
  
  const englishCount = englishLetters ? englishLetters.length : 0;
  const totalCount = text.length;  
  
  // If more than half of the characters are English letters, consider the text as English
  return englishCount / totalCount > 0.5;
}

const getValue = (data, name, language) => {
  const item = data.find(entry => entry.name === name);
  
  if (!item) return null;
  if (!item.value) return '-';
  
  if (name === "property_name") {
    const propValue = setHeightBasedOnString(item.value);
    // return propValue.splitStrings;
  }
  if (name === "property_name" || name==="role") {
    return isEnglish(item.value) ? item.value : convertTextToRtl(item.value);
  }

  const currencyNames = ["already_paid", "total_amount", "remaining_amount"];
  if (currencyNames.includes(name)) {
    const formattedValue = language === 'ar' ? `ر.س  ${item.value}` : `${item.value} SAR`;
    return formattedValue;
  }

  return item.value || "-";
};

export const generatePdf=(data, language, cardType)=>{
  const { accountNumTitle, roleTitle, meterNumTitle, nicknameTitle, totalAmountTitle, remainingAmountTitle, alreadyPaidTitle } = translations[language];

  const createBlock = (svg, title, value, width) => {
    const style = language === 'ar' ? 'headerSec' : 'headerEng';
    const valueStyle = language === 'ar' ? 'valueSec' : 'valueEng';

    return language === 'ar'
      ? [
          [{ text: convertTextToRtl(title), style }, { text: "  " }, { text: value, style: valueStyle }],
          { svg, width }
        ]
      : [
          { svg, width },
          [{ text: title, style }, { text: "  " }, { text: value, style: valueStyle }]
        ];
  };

  const blocksMap = {
    AccountInfoWithName: [
      createBlock(accountSVG, accountNumTitle, getValue(data, "contract_number"), 40),
      createBlock(userSVG, nicknameTitle, getValue(data, "property_name"), 30),
      createBlock(meterNumberSVG, meterNumTitle, getValue(data, "meter_number"), 30),
      createBlock(roleSVG, roleTitle, getValue(data, "role"), 35)
    ],
    AccountInfoWithoutName: [
      createBlock(accountSVG, accountNumTitle, getValue(data, "contract_number"), 40),
      createBlock(roleSVG, roleTitle, getValue(data, "role"), 35),
      createBlock(meterNumberSVG, meterNumTitle, getValue(data, "meter_number"), 30)
    ],
    BillInfo: [
      createBlock(accountSVG, accountNumTitle, getValue(data, "contract_number"), 40),
      // createBlock(alreadyPaidSVG, alreadyPaidTitle, getValue(data, "already_paid", language), 40),
      createBlock(amountSVG, totalAmountTitle, getValue(data, "total_amount", language), 40),
      // createBlock(amountSVG, remainingAmountTitle, getValue(data, "remaining_amount", language), 40)
    ]
  };

  const filenameMap = {
    AccountInfoWithName: 'card_account_info_',
    AccountInfoWithoutName: 'card_account_info_',
    BillInfo: 'card_bill_info_'
  };

  const newheight = pageheight(data, cardType);

  const blocksArray = blocksMap[cardType] || [];
  const filename = filenameMap[cardType] || 'card_info_';

  const docDef = language === 'ar' ? arbBlock({ blockArray: blocksArray }) : engBlock({ blockArray: blocksArray });

  handlePDFExport(docDef, filename, newheight);
}

const handlePDFExport = (data, filename='card_', newheight=singleLineheight) => {
  const docDefinition = {
    // a string or { width: number, height: number }
    pageSize: { width: 710, height: newheight },

    // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "landscape",

    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    pageMargins: [0, 0, 0, 0],
    content: data,
    styles: {
      headerSec: {
        fontSize: 18,
        alignment: "right",
        lineHeight: 0.85,
        font: "sec", // Use your custom font
      },
      valueSec: {
        fontSize: 24,
        bold: true,
        alignment: "right",
        font: "eng", // Use your custom font
      },
      headerEng: {
        fontSize: 18,
        alignment: "left",
        lineHeight: 0.85,
        font: "eng", // Use your custom font
      },
      valueEng: {
        fontSize: 24,
        bold: true,
        alignment: "left",
        font: "eng", // Use your custom font
      },
      column: {
        margin: [5, 5, 5, 5],
        border: [true, true, true, true],
        borderColor: "#d3d3d3",
        borderRadius: 10,
        padding: 10,
      },
    },
    defaultStyle: {
      font: "eng", // Set default font
    },
  };

  pdfMake.createPdf(docDefinition).download(`${filename}_${Date.now()}.pdf`);
}